import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setLocationCookies } from './setLocationCookies';
import { trackLocationAgree, trackPopupClose } from './tracking';
import { LocationDetectModal } from '../../components/LocationDetectModal';
// eslint-disable-next-line import/no-restricted-paths
import { useApplicationContext } from '../App/AppContext';
import { NBSP } from '../../constants/symbols';
import { removeCookie } from '../../../browser/utils/js-cookie';
import { selectDetectedLocation, selectSelectedRegion } from '../../selectors/geo';
import { DETECTED_REGION_ID_COOKIE_KEY } from '../../constants/detectedLocation';
import { geoPopupOpened } from '../../store/geo/actions';
import { selectIsMobile } from '../../selectors/mobile';
import { showMobileFilters } from '../../store/mobile/actions';
import { changeRegion } from '../../store/filters/actions';

export const LocationDetectModalContainer = () => {
  const detectedLocation = useSelector(selectDetectedLocation);
  const selectedRegion = useSelector(selectSelectedRegion);
  const isMobile = useSelector(selectIsMobile);
  const dispatch = useDispatch();
  const { config } = useApplicationContext();

  const subdomain = config.get<string>('subdomain');
  const [opened, setOpened] = React.useState(true);

  React.useEffect(() => {
    // Если определенный регион совпадает с регионом в куках, то удаляем куки,
    // чтобы не показывать попап при каждом заходе на сайт
    if (detectedLocation && subdomain && detectedLocation.baseHost.includes(subdomain)) {
      removeCookie(DETECTED_REGION_ID_COOKIE_KEY);
    }
  }, [detectedLocation, subdomain]);

  const title = React.useMemo(() => {
    if (!detectedLocation) {
      return '';
    }

    const { displayName } = detectedLocation;

    return `Ваш${NBSP}регион${NBSP}для${NBSP}поиска ${displayName}?`;
  }, [detectedLocation]);

  const onOpenChange = useEventCallback((open: boolean) => {
    if (detectedLocation && !open) {
      trackPopupClose(detectedLocation.displayName || '');
    }

    setOpened(open);
  });

  const onAgree = useEventCallback(() => {
    if (detectedLocation) {
      trackLocationAgree(detectedLocation.displayName || '');
      setLocationCookies(detectedLocation.id, detectedLocation.displayName || '', detectedLocation.mainTownId);
      removeCookie(DETECTED_REGION_ID_COOKIE_KEY);

      if (subdomain && detectedLocation.baseHost.includes(subdomain)) {
        setOpened(false);

        return;
      }

      window.location.href = `${detectedLocation.baseHost}${window.location.pathname}${window.location.search}`;
    }
  });

  const onRegionChange = useEventCallback(async () => {
    setOpened(false);
    removeCookie(DETECTED_REGION_ID_COOKIE_KEY);

    if (isMobile) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      await dispatch<any>(showMobileFilters(true));
      dispatch(geoPopupOpened());
    } else {
      if (selectedRegion) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dispatch<any>(changeRegion(selectedRegion, false, true));
      }
      dispatch(geoPopupOpened());
    }
  });

  if (!detectedLocation || !opened) {
    return null;
  }

  return (
    <LocationDetectModal title={title} onOpenChange={onOpenChange} onAgree={onAgree} onRegionChange={onRegionChange} />
  );
};
